///
/// EarthBrowser
///
/// Created by Matt Giger on 1/6/2025
/// Copyright (c) 2025 Geodata Labs
///

import { createApi } from '@reduxjs/toolkit/query/react'
import { bearerTokenQuery } from './bearerTokenQuery'

export const authenticatedApi = createApi({
	reducerPath: "authenticatedApi",
	baseQuery: bearerTokenQuery,
	tagTypes: [
		"BetaTesters",
		"FeatureFlags",
		"NotificationSettings",
		"PasskeyCredentials",
		"PrivacySettings",
		"Subscription",
		"UserProfile",
		"UserAccounts",
		"UserSubscription",
		"FullAccessOffer",

		"AirportFlights",
		"AirportSearch",
		"Aurora",
		"Buoys",
		"BuoyHistory",
		"Clouds",
		"Earthquakes",
		"Satellites",
		"Weather",
		"Wildfires",
		"Nexrad",
		"NexradHistory",
		"NexradLatest",
		"NexradStations",

		"OGCCollections",
		"OGCFeatures",

		"SensorThings",
		"SensorThingsDatastreams",
		"SensorThingsObservations",

		"GeoPackages",
		"GeoPackageCategories",
		"UserGeoPackages",
		"Collections",
		"UserCollections",
		"UserDatasets",
		"Shares", "PlacemarkAlerts", "PushSubscriptions",
	],
	endpoints: () => ({}),
})